<template>
  <HybridLoginForm @login-success="handleLoginSuccess" />
</template>

<script>
import HybridLoginForm from '../components/HybridLoginForm.vue'
import { normalizePostAuthLabPath } from '../utils/labRoutes.js'

export default {
  name: 'Login',
  inject: ['hideBackButton'],
  components: {
    HybridLoginForm
  },
  methods: {
    async handleLoginSuccess(user) {
      // Clear any existing session data to ensure a clean slate
      try {
        sessionStorage.clear()
        localStorage.removeItem('configuredData')
        localStorage.removeItem('processingResults')
        localStorage.removeItem('cohortFiles')
        localStorage.removeItem('cohortProcessingResults')
      } catch (error) {
        console.warn('Could not clear storage on login:', error)
      }
      
      // Store the session token immediately
      if (user.session_token) {
        localStorage.setItem('session_token', user.session_token)
      }

      // After login, App.vue will check processed-results S3 usage and may show a cleanup notice
      try {
        sessionStorage.setItem('sdm_pending_storage_check', '1')
      } catch (_) { /* ignore */ }
      
      // Wait a moment to ensure the auth state is updated
      await new Promise(resolve => setTimeout(resolve, 100))
      
      // Redirect: query.redirect (from auth guard) > backend lab path > /
      const redirect = this.$route.query.redirect
      const labPath = normalizePostAuthLabPath(
        user.redirect_path || (user.lab_id ? `/${user.lab_id}` : null)
      )
      let targetPath = '/'
      if (redirect && redirect.startsWith('/')) {
        targetPath = redirect.endsWith('/') ? redirect : redirect + '/'
      } else if (labPath) {
        targetPath = labPath.replace(/\/$/, '') + '/'
      }
      try {
        await this.$router.push(targetPath)
      } catch (error) {
        window.location.href = window.location.origin + targetPath
      }
    }
  },
  mounted() {
    // Hide back button on login page since this is the entry point for unauthenticated users
    this.hideBackButton()
  }
}
</script>
